/**
 * Module dependencies.
 */

import React from 'react';
import { cn } from 'app/lib/utils';

/**
 * `Props` type.
 */

type Props = {
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  level?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
};

/**
 * Size styles per level.
 */

const levelStyles: Record<NonNullable<Props['level']>, string> = {
  h1: 'pb-4 text-[28px] leading-tight',
  h2: 'text-2xl',
  h3: 'text-xl',
  h4: 'text-lg',
  h5: 'text-base',
  h6: 'text-sm'
};

/**
 * Export `Title` component.
 */

export function Title({ children, className, style, level = 'h1' }: Props): JSX.Element {
  return (
    <h1
      className={cn('block font-semibold tracking-tight text-foreground', levelStyles[level], className)}
      style={style}
    >
      {children}
    </h1>
  );
}
